import { AssignKioskRepository } from '../data/assign-kiosk-repository';
import { KioskLocation } from '../types/assign-kiosk-types';

export interface GetRemoteStartLocationsResult {
  locations: KioskLocation[];
  assignedLocationId: string | null;
  hasError: boolean;
  errorMessage?: string;
}

export class GetRemoteStartLocationsUseCase {
  constructor(private readonly repository: AssignKioskRepository) {}

  async execute(machineId: string): Promise<GetRemoteStartLocationsResult> {
    try {
      const result = await this.repository.getRemoteStartLocations(machineId);
      return { ...result, hasError: false };
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to load remote-start locations';
      return { locations: [], assignedLocationId: null, hasError: true, errorMessage };
    }
  }
}
